import CreateTemplateTab from "../../components/CreateTamplateTab";
import BasicCard from "../BasicCard"
import Dummylayout from "../Dummylayout";
function CreateTemplateMain(){

    return(
       <>
       <Dummylayout/>
     <BasicCard>
        <CreateTemplateTab/>
     </BasicCard>
     
        
       </>

    )
};
export default CreateTemplateMain;
